<template>
  <el-color-picker
    v-model="theme"
    :predefine="['#409EFF', '#1890ff', '#1e78bf','#304156','#212121','#11a983', '#13c2c2', '#6959CD', '#f5222d']"
    class="theme-picker"
    popper-class="theme-picker-dropdown"
  />
</template>
<script>
const version = require('element-ui/package.json').version
const ORIGINAL_THEME = '#409EFF'
export default {
    name: 'ThemePicker',
    props: {
        default: {
            type: String,
            default: ORIGINAL_THEME
        }
    },
    data() {
        return {
            chalk: '', // content of theme-chalk css
            theme: ORIGINAL_THEME,
            showSuccess: true // 是否弹出换肤成功消息
        }
    },
    mounted() {
        if (this.default !== null) {
            this.theme = this.default
            this.$emit('change', this.theme)
            this.showSuccess = false
        }
    },
    watch: {
        theme(val, oldVal) {
            if (typeof val !== 'string') {
                return
            }           
            // 响应外部操作
            this.$emit('change', val)
            //存入localStorage
            if (this.showSuccess) {
                this.$message({
                    message: '换肤成功',
                    type: 'success'
                })
            } else {
                this.showSuccess = true
            }
        }
    },
    methods: {
    }
}
</script>

<style>
.theme-picker .el-color-picker__trigger {
    vertical-align: middle;
}

.theme-picker-dropdown .el-color-dropdown__link-btn {
    display: none;
}
</style>